export const messages: Record<string, string> = {
  // Navigation
  'nav.news': 'Notizie',
  'nav.team': 'Squadra',

  // Common
  'common.save': 'Salva',
  'common.saving': 'Salvataggio...',
  'common.cancel': 'Annulla',
  'common.back': 'Indietro',
  'common.edit': 'Modifica',
  'common.delete': 'Elimina',
  'common.loading': 'Caricamento...',
  'common.publish': 'Pubblica',
  'common.publishing': 'Salvataggio…',

  // News
  'news.title': 'Articoli',
  'news.new': 'Nuovo articolo',
  'news.create': 'Scrivi articolo',
  'news.edit': 'Modifica articolo',
  'news.empty': 'Nessun articolo presente.',
  'news.loadError': 'Errore durante il caricamento degli articoli',
  'news.saveSuccess': 'Articolo salvato con successo.',
  'news.saveError': 'Errore durante il salvataggio: {message}',
  'news.publishError': 'Errore durante la pubblicazione: {message}',
  'news.category': 'Categoria',
  'news.categoryPlaceholder': 'Seleziona una categoria',
  'news.titleLabel': 'Titolo',
  'news.titlePlaceholder': 'Titolo del tuo articolo',
  'news.titleInput': 'Inserisci titolo*',
  'news.shortDescription': 'Breve descrizione',
  'news.shortDescriptionLabel': 'Breve descrizione*',
  'news.shortDescriptionPlaceholder':
    'Riassumi brevemente il contenuto del tuo articolo.',
  'news.category.news': 'Notizie',
  'news.category.events': 'Eventi',
  'news.category.updates': 'Aggiornamenti',

  // Team
  'team.title': 'Membri del team',
  'team.new': 'Nuovo membro',
  'team.create': 'Aggiungi membro',
  'team.edit': 'Modifica membro',
  'team.empty': 'Nessun membro presente.',
  'team.loadError': 'Errore durante il caricamento dei membri',
  'team.saveSuccess': 'Membro salvato con successo.',
  'team.updateSuccess': 'Modifiche salvate.',
  'team.saveError': 'Errore durante il salvataggio: {message}',
  'team.name': 'Nome',
  'team.namePlaceholder': 'Inserisci nome',
  'team.group': 'Squadra',
  'team.groupPlaceholder': 'Seleziona gruppo',
  'team.level': 'Livello di formazione',
  'team.levelPlaceholder': 'Seleziona livello',
  'team.role': 'Ruolo',
  'team.rolePlaceholder': 'Seleziona posizione',
  'team.expirationDate': 'Data di scadenza',
  'team.expirationDatePlaceholder': 'Seleziona data',
  'team.expirationLabel': 'fino al {date}',
};
